import React, { Component } from 'react';

import arrowLeft from "../../assets/images/icons/arrow-left.svg";
import arrowRight from "../../assets/images/icons/arrow-right.svg";
import clientImg from "../../assets/images/client-photo.png";

import ClientReviewsSlide from './clients-reviews-slide';


class ClientsReviews extends Component {

    componentDidMount() {

    }

    render() {
        return (
            <div className="clients-reviews">
                <div className="container">
                     <div className="clients-reviews-slider-wrapper">
                        <div className="title-content d-flex align-items-center">
                            <div className="position-relative">
                                <h3 className="title">ماذا يقول عملائنا عنا</h3>
                                <div className="swiper-arrows-container">
                                    <div className="swiper-button-prev client-review-prev-btn cassandra-slider-btn">
                                        <img className="img-fluid" src={arrowRight} alt="arrow icon"/>
                                    </div>
                                    <div className="swiper-button-next client-review-next-btn cassandra-slider-btn">
                                        <img  className="img-fluid" src={arrowLeft} alt="arrow icon"/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*Start Slider */}
                        <div className="clients-reviews-slider">
                            <div className="swiper-container reviews-slider">
                                 <div className="swiper-wrapper">
                                     <ClientReviewsSlide slideImgClient={clientImg} clientName={"عمر مؤمن"} clientPosition={"المدير التنفيذى لشركة"} clientReviewDescription={"تتناول هذه المقالة شركة البريد السريع منذ عام 2011. للاطلاع على سابقتها بين عامي 1998 و 2011  لسلفها قبل عام  تتناول هذه المقالة شركة البريد السريع منذ عام 2011. للاطلاع على سابقتها بين عامي 1998 و 2011  لسلفها قبل عام 1998 ، 1998 ،"}/>
                                     <ClientReviewsSlide slideImgClient={clientImg} clientName={"عمر مؤمن"} clientPosition={"المدير التنفيذى لشركة"} clientReviewDescription={"تتناول هذه المقالة شركة البريد السريع منذ عام 2011. للاطلاع على سابقتها بين عامي 1998 و 2011  لسلفها قبل عام  تتناول هذه المقالة شركة البريد السريع منذ عام 2011. للاطلاع على سابقتها بين عامي 1998 و 2011  لسلفها قبل عام 1998 ، 1998 ،"}/>
                                     <ClientReviewsSlide slideImgClient={clientImg} clientName={"عمر مؤمن"} clientPosition={"المدير التنفيذى لشركة"} clientReviewDescription={"تتناول هذه المقالة شركة البريد السريع منذ عام 2011. للاطلاع على سابقتها بين عامي 1998 و 2011  لسلفها قبل عام  تتناول هذه المقالة شركة البريد السريع منذ عام 2011. للاطلاع على سابقتها بين عامي 1998 و 2011  لسلفها قبل عام 1998 ، 1998 ،"}/>
                                     <ClientReviewsSlide slideImgClient={clientImg} clientName={"عمر مؤمن"} clientPosition={"المدير التنفيذى لشركة"} clientReviewDescription={"تتناول هذه المقالة شركة البريد السريع منذ عام 2011. للاطلاع على سابقتها بين عامي 1998 و 2011  لسلفها قبل عام  تتناول هذه المقالة شركة البريد السريع منذ عام 2011. للاطلاع على سابقتها بين عامي 1998 و 2011  لسلفها قبل عام 1998 ، 1998 ،"}/>
                                 </div>
                            </div>
                        </div>

                     </div>  
                </div>
            </div>
        )
    }

};
export default ClientsReviews;


